import { useTrackTranscription } from "@livekit/components-react";

import { View, StyleSheet } from "react-native";
import CustomText from "../../components/common/general/CustomText/CustomText";
import { useVoiceAssistant } from "@livekit/components-react";
import { ScrollView } from "react-native-gesture-handler";
import { useEffect, useState, useRef } from "react";
import { SIMPLE_VOICE_ASSISTANT_HEIGHT } from "../../constants/assessmentConstants";

interface Segment {
  text: string;
  timestamp: number;
}

interface SimpleVoiceAssistantProps {
  questionIndex: number;
}

function SimpleVoiceAssistant({ questionIndex }: SimpleVoiceAssistantProps) {
  const { audioTrack } = useVoiceAssistant();
  const { segments } = useTrackTranscription(audioTrack);
  const [currentQuestionSegments, setCurrentQuestionSegments] = useState<Segment[]>([]);
  const lastQuestionIndex = useRef(0);
  const segmentStartIndex = useRef(0);

  useEffect(() => {
    if (questionIndex !== lastQuestionIndex.current && questionIndex > 0) {
      lastQuestionIndex.current = questionIndex;
      segmentStartIndex.current = segments.length;
      setCurrentQuestionSegments([]);
    }
  }, [questionIndex]);

  useEffect(() => {
    if (questionIndex > 0 && segments.length > 0) {
      // Get all segments from the start index of the current question
      const questionSegments = segments.slice(segmentStartIndex.current);

      if (questionSegments.length > 0) {
        setCurrentQuestionSegments(
          questionSegments.map((segment) => ({
            text: segment.text,
            timestamp: segment.timestamp,
          }))
        );
      }
    }
  }, [segments, questionIndex]);

  const currentQuestionText =
    currentQuestionSegments.length > 0 ? currentQuestionSegments.map((segment) => segment.text).join(" ") : "";

  return (
    <View style={styles.transcriptContainer}>
      <ScrollView style={styles.scrollView}>
        {currentQuestionText && (
          <CustomText
            text={currentQuestionText}
            size="xl"
            weight="normal"
            style={styles.transcriptText}
            useTranslationText={false}
          />
        )}
      </ScrollView>
    </View>
  );
}

const styles = StyleSheet.create({
  transcriptContainer: {
    flex: 1,
    padding: 20,
    justifyContent: "center",
    alignItems: "center",
    height: SIMPLE_VOICE_ASSISTANT_HEIGHT,
  },
  transcriptText: {
    width: "100%",
    maxWidth: 675,
    textAlign: "center",
    color: "#667085",
  },
  scrollView: {
    height: 100,
    width: "100%",
  },
});

export default SimpleVoiceAssistant;
